import { LEVEL } from '_utils/level';
import { shuffleArray } from '_utils/shuffle';

const LOOSE_BY_LEVEL = {
  [LEVEL.EASY]: 5,
  [LEVEL.MEDIUM]: 3,
  [LEVEL.HARD]: 1,
};

const cellKey = (x, y) => `${Number(x)},${Number(y)}`;

const isFilled = cell =>
  cell != null && cell.text != null && String(cell.text).trim() !== '';

function findWords(table, rows, columns) {
  const map = new Map();
  table.filter(isFilled).forEach(cell => {
    map.set(cellKey(cell.positionx, cell.positiony), cell);
  });

  const words = [];

  const collect = horizontal => {
    const outerMax = horizontal ? rows : columns;
    const innerMax = horizontal ? columns : rows;

    for (let outer = 0; outer < outerMax; outer += 1) {
      let inner = 0;
      while (inner < innerMax) {
        const x = horizontal ? inner : outer;
        const y = horizontal ? outer : inner;

        if (!map.has(cellKey(x, y))) {
          inner += 1;
        } else {
          const cells = [];
          while (inner < innerMax) {
            const cx = horizontal ? inner : outer;
            const cy = horizontal ? outer : inner;
            const cell = map.get(cellKey(cx, cy));
            if (!cell) break;
            cells.push(cell);
            inner += 1;
          }
          if (cells.length >= 3) words.push(cells);
        }
      }
    }
  };

  collect(true);
  collect(false);
  return words;
}

export function buildLetrexEnigmaTable(item = {}, { withHints = false } = {}) {
  const table = item.table || [];
  const revealed = new Set();

  if (withHints) {
    const words = findWords(
      table,
      Number(item.rows) || 0,
      Number(item.columns) || 0,
    );

    if (words.length) {
      shuffleArray(words)[0].forEach(cell => {
        revealed.add(cellKey(cell.positionx, cell.positiony));
      });
    }

    const looseCount =
      LOOSE_BY_LEVEL[item.level] ?? LOOSE_BY_LEVEL[LEVEL.MEDIUM];
    shuffleArray(
      table.filter(
        cell =>
          isFilled(cell) &&
          !revealed.has(cellKey(cell.positionx, cell.positiony)),
      ),
    )
      .slice(0, looseCount)
      .forEach(cell => {
        revealed.add(cellKey(cell.positionx, cell.positiony));
      });
  }

  return table.map(cell => {
    if (!isFilled(cell)) return { ...cell, text: null };
    return {
      ...cell,
      text: revealed.has(cellKey(cell.positionx, cell.positiony))
        ? cell.text
        : '',
    };
  });
}
